import React from "react";
import styled from "styled-components";


export default styled.div`
    width: 100%;
    height: auto;
    background: white;
    border-radius: 5px;
    padding: 11px 25px 11px 0;
    box-sizing: border-box;
    margin-bottom: 0;
    text-align: left;
    text-decoration: none;
    overflow: visible;

    @media(max-width: 768px) {
        height: auto;
    }

`;
